<template>
  <div class="inputfiles-container">
    <div v-for="(file, index) in modelValue" :key="index">
      <template v-if="!file.is_delete">
        <input-file v-model="modelValue[index]" :name="inputName(index)" :input-name="inputName" :name-label="nameLabel" :base-url="baseUrl" :error="file.error" :disabled="disabled" ></input-file>
        <span class="remove-container" @click="removeContainer(index)" v-if="!disabled">
          <i class="fa-solid fa-trash-can"></i>
        </span>
      </template>
    </div>
    <div class="add-file-container" :class="{'input-name':inputName}" v-if="!disabled">
      <span @click="addFile"></span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InputFile from './InputFile.vue'

export default defineComponent({
  props:['modelValue', 'name', 'inputName', 'nameLabel', 'baseUrl', 'disabled'],
  setup(props, context) {
    /**
     * ファイルを追加します
     */
    const addFile = () => {
      const file = {}
      if (!Array.isArray(props.modelValue)) {
        context.emit('update:modelValue', [file])
      } else {
        props.modelValue.push(file)
        context.emit('update:modelValue', props.modelValue)
      }
    }

    /**
     * ファイルのコンテナを削除します
     * @param index 
     */
    const removeContainer = (index: number) => {
      if (props.modelValue[index].hasOwnProperty('file'))  {
        delete props.modelValue[index].file
      }
      if (props.modelValue[index].hasOwnProperty('name'))  {
        delete props.modelValue[index].name
      }
      props.modelValue[index].is_delete = true
      context.emit('update:modelValue', props.modelValue)
    }

    /**
     * INPUTタグのNAME属性を返します
     * @param idx 
     */
    const inputName = (idx: number) => {
      return props.name + idx
    }

    return {
      addFile,
      removeContainer,
      inputName
    }
  },
  components: {
    'input-file': InputFile
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/form/input-files.scss';
</style>